import { Reminder } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/ReminderModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
    type: Reminder.GET_ALL_REMINDER_LIST_INIT,
});

const success = (data) => ({
    type: Reminder.GET_ALL_REMINDER_LIST_SUCCESS,
    payload: {
        data
    }
});

const failure = () => ({
    type: Reminder.GET_ALL_REMINDER_LIST_FAILURE,
});

const getAllRemindersList = (params) => async (dispatch) => {
    dispatch(init());
    try {
        dispatch(ViewManagementModule.Actions.showLoader());
        const { data } = await Connector.getAllRemindersList(params);
        dispatch(success(data));
        dispatch(ViewManagementModule.Actions.hideLoader());
    } catch (err) {
        dispatch(ViewManagementModule.Actions.hideLoader());
        dispatch(failure());
    }
};

export default getAllRemindersList;
